export default {
  title: 'Dashboard',
  welcome: 'Welcome back',
  overview: 'Overview',
  lastResources: 'Last resources',
  stats: {
    totalResources: 'Total Resources',
    availableResources: 'Available Resources',
    categories: 'Categories',
    recentResources: 'Recent Resources'
  },
  happeningToday: 'Here\'s what\'s happening with your application today.'
};
